import { render, staticRenderFns } from "./AxRowFooter2.vue?vue&type=template&id=322d3be0&scoped=true"
import script from "./AxRowFooter2.vue?vue&type=script&lang=ts"
export * from "./AxRowFooter2.vue?vue&type=script&lang=ts"
import style0 from "./AxRowFooter2.vue?vue&type=style&index=0&id=322d3be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d3be0",
  null
  
)

export default component.exports